import { makeStyles } from '@mui/styles';
import { COLORS } from '@styles/colors';

export const useStyles = makeStyles({
  alert: {
    width: 'fit-content',
    whiteSpace: 'pre-line',
  },
  accountingAlert: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: 'rgba(0, 0, 0, 0.6)',

    '& svg': {
      color: 'rgba(0, 0, 0, 0.38)',
    },
  },
  resolutionEop: {
    marginBottom: 16,
  },
  textField: {
    marginBottom: '16px',
    maxWidth: '750px',
    display: 'block',
  },
  pointsToConsider: {
    background: COLORS.HIGHLIGHTS.PROMINENT,
    padding: '38px 40px !important',
    position: 'sticky',
    borderRadius: '4px',
    alignSelf: 'flex-start',
  },
});
